import React from 'react';

//TODO: PropTypes
function VerifyResend(props) {
    let elem;
    if (props.showOptions) {
        elem = (
            <div className="asc-secondary-text">
                <button
                    type="button"
                    className="asc-btn asc-btn--link"
                    onClick={props.handleResend}
                >
                    Resend code
                </button>{' '}
                or <a href={props.resendUrl}>Try another option</a>
            </div>
        );
    } else {
        elem = (
            <button type="button" className="asc-btn asc-btn--link" onClick={props.handleResend}>
                Resend code
            </button>
        );
    }
    return elem;
}

export default VerifyResend;
